
<template>
  <div class="page-header">
      <div class="main-nav">
          <div class="nav-left">
            <img class="logo-img" :src="logoImg">
          </div>
          <div class="flex-spacer"></div>
          <div class="nav-right">
            <div class="theme-toggle" @click="toggleTheme">
              <img class="nav-icon" :src="currentTheme === 'light' ? sunIcon : moonIcon" :alt="currentTheme">
            </div>
            <img class="nav-icon lang-toggle-icon" src="../assets/svg/language.svg" @click="toggleLanguageList">
          </div>
      </div>
  </div>


  <div v-if="showLanguageList" class="bank_title_item">
    <div 
      v-for="language in languages" 
      :key="language.code" 
      class="language-option"
      @click="selectLanguage(language)"
    >
      <span class="lang-name">{{ language.name }}</span>
      <img class="lang-flag" :src="getLanguageFlagUrl(language.flag)">
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { languages, getLanguageFlagUrl } from '../config/languages.js'
import sunIcon from '@/assets/svg/sun.svg'
import moonIcon from '@/assets/svg/moon.svg'
import logoImg from '@/assets/static/121212e.png'
import '@/assets/css/header.css'

const route = useRoute()
const router = useRouter()
const { t, locale } = useI18n()

const showLanguageList = ref(false)
const currentTheme = ref('light')

const goBack = () => {
  router.back()
}

const showBackButton = () => {
  return route.path !== '/'
}

const toggleLanguageList = () => {
  showLanguageList.value = !showLanguageList.value
}

const selectLanguage = (language) => {
  locale.value = language.code
  localStorage.setItem('locale', language.code)
  showLanguageList.value = false
}

const getCurrentLanguageFlag = () => {
  const currentLang = languages.find(lang => lang.code === locale.value)
  return currentLang ? getLanguageFlagUrl(currentLang.flag) : ''
}

const toggleTheme = () => {
  currentTheme.value = currentTheme.value === 'light' ? 'dark' : 'light'
  document.documentElement.setAttribute('data-theme', currentTheme.value)
  localStorage.setItem('theme', currentTheme.value)
}

onMounted(() => {
  const savedTheme = localStorage.getItem('theme') || 'light'
  currentTheme.value = savedTheme
  document.documentElement.setAttribute('data-theme', savedTheme)
})
</script>

<style scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
</style>

